import { Outlet } from 'react-router-dom';

function Clients(){
    return(
        <Outlet/>
    );
}

export default Clients;
  